/**
 * @desc 找到并删除入库计划单
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.inPlanFacadeImpl.getAndDelete.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inPlan/getAndDelete`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
